import { Typography } from 'antd';
import React, { useContext } from 'react';
import { CartStateContext } from '~/App/Layout/providers/CartProvider';
import { formatCurrency } from '~/utils/currency';
import i18n from '~/i18n';
import './style.css';
import { useGetMenuItemPriceById } from '~/App/hooks/useMenu';

const TotalSection = () => {
  const items = useContext(CartStateContext);
  const getItemPriceById = useGetMenuItemPriceById();

  const total = items.reduce((acc, item) => {
    // Use totalPrice directly if item is a custom.
    if (item.custom) {
      return acc + (item.totalPrice ?? 0);
    }

    acc += getItemPriceById(item.menuId) * item.quantity;
    item.addOns.forEach(({ menuId: addOnId, quantity }) => {
      acc += getItemPriceById(addOnId) * quantity;
    });
    return acc;
  }, 0);
  return (
    <div className="cart-total-section">
      <Typography.Title level={5} style={{ margin: 0 }}>
        {i18n.t('menu_total')}
      </Typography.Title>
      <Typography.Title level={5} style={{ margin: 0 }}>
        {formatCurrency(total)}
      </Typography.Title>
    </div>
  );
};

export default TotalSection;
